/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** VisitStatusEnum */
export enum VisitStatusEnum {
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

/** RequestStatusEnum */
export enum RequestStatusEnum {
  SUBMITTED = 'SUBMITTED',
  UNFULFILLED = 'UNFULFILLED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
}

/** PaymentMethod */
export enum PaymentMethod {
  Cash = 'cash',
  Card = 'card',
}

/**
 * LinePricingModeEnum
 * Mirror of the ``enum_line_pricing_mode`` Postgres type.
 *
 * Values are lowercase to match the database labels exactly, following
 * ``InventoryMovementTypeEnum`` and the other DB-backed enums in
 * ``models/inventory.py`` rather than the UPPERCASE domain enums in
 * ``models/enums.py``.
 *
 * ``PER_SERVICE`` is the pre-package behaviour and the column default: a line's
 * money is its slot-services' own cost/price. ``PACKAGE`` means the line's own
 * price/cost is authoritative, snapshotted when the package was sold.
 *
 * ``ALLOCATED`` and ``LUMP_SUM`` are phase 5, appended to the Postgres type with
 * ``ALTER TYPE ... ADD VALUE`` - no migration of existing rows and no breaking
 * change to callers that only ever send the first two.
 *
 * ``ALLOCATED`` spreads the line's own price back over its slot services, so
 * each delivered service carries a share and the ordinary per-visit billing
 * path bills the package. It is the mode ``PACKAGE`` left undone: a ``PACKAGE``
 * line's slot services carry no money at all, so its visits bill nothing.
 *
 * WHICH IS WHY SELLING A PACKAGE STORES ``ALLOCATED``, NOT ``PACKAGE``. A line
 * in ``PACKAGE`` mode is never invoiced by anything: its visits bill 0 and no
 * line-level charge is raised for it either (that is ``LUMP_SUM``'s job). See
 * ``_resolve_line_pricing``, which resolves a sale to ``ALLOCATED`` when a price
 * resolves for the package and to ``PER_SERVICE`` when none does. ``PACKAGE``
 * remains a storable, explicitly requestable mode, and the lines already written
 * in it keep their meaning - nothing here migrates them.
 *
 * ``LUMP_SUM`` bills the line ONCE, as a single amount, rather than per
 * delivered service. Its slot services carry no price and a single
 * ``client_charge`` is posted against the line - see
 * ``homecare.crud.line_billing_sync``.
 *
 * COST IS NEVER ALLOCATED in any mode. A cost is what the business pays a
 * caregiver; it does not shrink because the client got a bundle discount.
 */
export enum LinePricingModeEnum {
  PerService = 'per_service',
  Package = 'package',
  Allocated = 'allocated',
  LumpSum = 'lump_sum',
}

/**
 * CollectUnit
 * Mirror of ``enum_collect_unit``.
 *
 * ``MONTHS`` is a CALENDAR month, not 30 days - a monthly collection that
 * drifts two days a quarter is not a monthly collection. The arithmetic in
 * ``homecare.payments.collection`` walks calendar months for that reason.
 */
export enum CollectUnit {
  Visits = 'visits',
  Days = 'days',
  Months = 'months',
}

/**
 * CollectTiming
 * Mirror of ``enum_collect_timing``: which visit of a period collects.
 *
 * ``FIRST_VISIT`` is paid upfront, ``LAST_VISIT`` after the service. NULL in the
 * database reads as ``LAST_VISIT``, which is what every row did before this existed.
 */
export enum CollectTiming {
  FirstVisit = 'first_visit',
  LastVisit = 'last_visit',
}

/**
 * CollectAnchor
 * Mirror of ``enum_collect_anchor``: how a MONTHS cadence cuts its periods.
 *
 * Since 20260928120000 every unit uses fixed periods (see
 * ``homecare.payments.collection``). Two values still change the arithmetic,
 * whatever the unit, because that is what they always meant:
 * ``PER_VISIT`` makes every visit its own period, and ``DAY_OF_MONTH`` runs
 * N-month periods from day X to the day before X (X in
 * ``Cadence.collect_anchor_day``). ``PERIOD_START``/``PERIOD_END``/``None`` mean
 * groups of N visits, N-day blocks or N calendar months.
 */
export enum CollectAnchor {
  PeriodStart = 'period_start',
  PeriodEnd = 'period_end',
  PerVisit = 'per_visit',
  DayOfMonth = 'day_of_month',
}

/** CaregiverServiceRequestResponse */
export interface CaregiverServiceRequestResponse {
  /** Caregiverid */
  caregiverId: number;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
}

/**
 * ClientServiceRequestResponse
 * Client with service request details
 */
export interface ClientServiceRequestResponse {
  /** Clientid */
  clientId: number;
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/**
 * LineDeliveryReport
 * Of the services this line promised, how many are done and how many remain.
 *
 * Built from REAL VISIT DATA - the line's visits and their ``visit_services`` -
 * not from the line's definition re-expanded. The definition says what the line
 * would generate today; the visits say what was actually scheduled, and those
 * differ the moment a coordinator cancels one or regeneration leaves a protected
 * visit in place. A coordinator asking "what does this client still have coming"
 * is asking about the visits.
 *
 * How each ``enum_visit_status`` counts:
 *
 * * ``COMPLETED``   -> delivered.
 * * ``SCHEDULED``   -> outstanding (still owed).
 * * ``IN_PROGRESS`` -> outstanding. Started is not finished: money is booked on
 *   completion (``sync_billing_transactions_for_completed_visit`` refuses any
 *   other status), so treating it as delivered would report revenue that has not
 *   been earned. Surfaced separately as ``inProgress`` so it is visible.
 * * ``CANCELLED``   -> neither. Reported on its own line.
 */
export interface LineDeliveryReport {
  /** Lineid */
  lineId: number;
  /** Servicerequestid */
  serviceRequestId: number;
  /**
   * Mirror of the ``enum_line_pricing_mode`` Postgres type.
   *
   * Values are lowercase to match the database labels exactly, following
   * ``InventoryMovementTypeEnum`` and the other DB-backed enums in
   * ``models/inventory.py`` rather than the UPPERCASE domain enums in
   * ``models/enums.py``.
   *
   * ``PER_SERVICE`` is the pre-package behaviour and the column default: a line's
   * money is its slot-services' own cost/price. ``PACKAGE`` means the line's own
   * price/cost is authoritative, snapshotted when the package was sold.
   *
   * ``ALLOCATED`` and ``LUMP_SUM`` are phase 5, appended to the Postgres type with
   * ``ALTER TYPE ... ADD VALUE`` - no migration of existing rows and no breaking
   * change to callers that only ever send the first two.
   *
   * ``ALLOCATED`` spreads the line's own price back over its slot services, so
   * each delivered service carries a share and the ordinary per-visit billing
   * path bills the package. It is the mode ``PACKAGE`` left undone: a ``PACKAGE``
   * line's slot services carry no money at all, so its visits bill nothing.
   *
   * WHICH IS WHY SELLING A PACKAGE STORES ``ALLOCATED``, NOT ``PACKAGE``. A line
   * in ``PACKAGE`` mode is never invoiced by anything: its visits bill 0 and no
   * line-level charge is raised for it either (that is ``LUMP_SUM``'s job). See
   * ``_resolve_line_pricing``, which resolves a sale to ``ALLOCATED`` when a price
   * resolves for the package and to ``PER_SERVICE`` when none does. ``PACKAGE``
   * remains a storable, explicitly requestable mode, and the lines already written
   * in it keep their meaning - nothing here migrates them.
   *
   * ``LUMP_SUM`` bills the line ONCE, as a single amount, rather than per
   * delivered service. Its slot services carry no price and a single
   * ``client_charge`` is posted against the line - see
   * ``homecare.crud.line_billing_sync``.
   *
   * COST IS NEVER ALLOCATED in any mode. A cost is what the business pays a
   * caregiver; it does not shrink because the client got a bundle discount.
   * @default "per_service"
   */
  pricingMode?: LinePricingModeEnum;
  /** Packageid */
  packageId?: number | null;
  /** Packagename */
  packageName?: string | null;
  /**
   * Promised
   * @default 0
   */
  promised?: number;
  /**
   * Delivered
   * @default 0
   */
  delivered?: number;
  /**
   * Outstanding
   * @default 0
   */
  outstanding?: number;
  /**
   * Scheduled
   * @default 0
   */
  scheduled?: number;
  /**
   * Inprogress
   * @default 0
   */
  inProgress?: number;
  /**
   * Cancelled
   * @default 0
   */
  cancelled?: number;
  /**
   * Visitcount
   * @default 0
   */
  visitCount?: number;
  /**
   * Completedvisitcount
   * @default 0
   */
  completedVisitCount?: number;
  /**
   * Fullydelivered
   * @default false
   */
  fullyDelivered?: boolean;
  /**
   * Services
   * @default []
   */
  services?: LineDeliveryServiceRow[];
}

/**
 * LineDeliveryServiceRow
 * What has actually been delivered of ONE service on a line.
 *
 * Counted in SERVICE UNITS, not in visits: ``visit_services`` has no quantity
 * column, so a per-day quantity of 2 is two rows on the visit, and counting rows
 * is what makes "2 of the 6 medication administrations are done" come out right.
 *
 * ``promised`` is ``delivered + outstanding`` and deliberately EXCLUDES cancelled
 * units. A cancelled visit was never delivered and is no longer owed, so
 * including it would make a line whose visits were all cancelled look permanently
 * part-delivered and never let ``fullyDelivered`` become true. It is reported
 * separately, because "3 cancelled" is information a coordinator needs when the
 * numbers do not add up to what was sold.
 */
export interface LineDeliveryServiceRow {
  /** Serviceid */
  serviceId: number;
  /** Name */
  name?: string | null;
  /**
   * Promised
   * @default 0
   */
  promised?: number;
  /**
   * Delivered
   * @default 0
   */
  delivered?: number;
  /**
   * Outstanding
   * @default 0
   */
  outstanding?: number;
  /**
   * Scheduled
   * @default 0
   */
  scheduled?: number;
  /**
   * Inprogress
   * @default 0
   */
  inProgress?: number;
  /**
   * Cancelled
   * @default 0
   */
  cancelled?: number;
}

/**
 * LineRegenerationSummary
 * What regenerating one line's visits did, or would do.
 *
 * The same shape for the preview and the apply — they are built by one function
 * from one plan — with ``dry_run`` as the only field that distinguishes them, so
 * a caller can never mistake one for the other.
 *
 * ``created + kept`` is what the line's definition now calls for;
 * ``deleted + skipped_protected`` is what it no longer calls for, split by
 * whether it was safe to remove.
 */
export interface LineRegenerationSummary {
  /** Lineid */
  lineId: number;
  /** Dryrun */
  dryRun: boolean;
  /** Created */
  created: number;
  /** Kept */
  kept: number;
  /** Deleted */
  deleted: number;
  /** Skippedprotected */
  skippedProtected: number;
  /**
   * Createdstarttimes
   * @default []
   */
  createdStartTimes?: string[];
  /**
   * Deletedvisitids
   * @default []
   */
  deletedVisitIds?: number[];
  /**
   * Protectedvisits
   * @default []
   */
  protectedVisits?: ProtectedVisitDb[];
}

/**
 * LineRepricingSummary
 * What repricing one line's visits did, or would do.
 *
 * The same shape for the preview and the apply, built by one function from one
 * plan, with ``dry_run`` the only field that distinguishes them.
 *
 * ``line_unpriced`` is set when the line's pricing mode carries no per-visit
 * money at all - today, ``package`` - in which case nothing is eligible and
 * nothing is written. Reported as its own field rather than as an empty result,
 * because "there is nothing to reprice" and "this line cannot be repriced" need
 * different words on screen.
 *
 * ``charges_visible`` is false for a session flagged ``app.billing_blocked`` - an
 * Office Administrator. Nothing is eligible then, because RLS hides rows rather
 * than raising, so an unseen charge would read as no charge and an already-billed
 * visit would look repriceable. Carried on the summary so the preview can SAY so,
 * in place of offering the choice.
 *
 * THE NAME IS NOW WIDER THAN WHAT IT MEASURES. It used to be exact: the blanket
 * ``billing_block_admin_inheritors`` policy denied a blocked session every row of
 * ``billing_transactions``. Migration 20260822180000 split that per command, so an
 * ofa READS ``client_charge`` and ``client_payment`` and is refused only UPDATE and
 * DELETE. Repricing WRITES, so false is still exactly the right answer here - but
 * do not re-derive this flag from a charge count on the strength of the rows now
 * being readable. See the note above ``CHARGES_VISIBLE_SQL``.
 */
export interface LineRepricingSummary {
  /** Lineid */
  lineId: number;
  /** Dryrun */
  dryRun: boolean;
  /** Repriced */
  repriced: number;
  /** Skippedprotected */
  skippedProtected: number;
  /**
   * Lineunpriced
   * @default false
   */
  lineUnpriced?: boolean;
  /**
   * Chargesvisible
   * @default true
   */
  chargesVisible?: boolean;
  /**
   * Repricedvisits
   * @default []
   */
  repricedVisits?: RepricedVisitDb[];
  /**
   * Protectedvisits
   * @default []
   */
  protectedVisits?: ProtectedFromRepricingDb[];
}

/**
 * LineStaffingDb
 * Who staffs a line, DERIVED from the line's visits.
 *
 * The read-back counterpart of :class:`LineStaffingFields`, and deliberately not
 * its mirror image. Nothing about staffing is stored on
 * ``service_request_lines``; ``visit_caregivers`` is the only home the assignment
 * has, and ``PATCH /visits/{id}`` reassigns one visit at a time. So a line's
 * visits NEED NOT share caregivers, and after a month of real use usually do not:
 * Maria on most of them, Eleni on three.
 *
 * That is why this reports a SET and a flag rather than a caregiver. A single id
 * here would let an edit screen show one name, and a coordinator saving an
 * unrelated change would then re-staff every visit to that one person, silently
 * destroying the per-visit assignments. ``caregiverIds`` plus ``uniform`` makes
 * "this line is Maria's" and "this line is mostly Maria's" different values, so
 * the second cannot be mistaken for the first.
 *
 * WHICH VISITS ARE COUNTED: only the line's ``SCHEDULED`` and ``IN_PROGRESS``
 * visits - i.e. exactly the OUTSTANDING ones, the same set
 * :class:`LineDeliveryReport` calls outstanding.
 *
 * * ``CANCELLED`` is excluded. A cancelled visit is not work: nobody will do it,
 *   and whoever was booked on it does not staff the line. This is the same
 *   exclusion ``promised``/``outstanding`` already make.
 * * ``COMPLETED`` is excluded. It is history, and history names people who may
 *   have left. Prefilling an editor from it and saving would stamp a departed
 *   caregiver onto freshly created visits - and the completed visits themselves
 *   can never be re-staffed by a line edit anyway (they are protected), so their
 *   caregivers are not information an editor can act on.
 * * ``IN_PROGRESS`` is included: it is live work, done by the person who will
 *   most likely do the rest.
 *
 * A line whose outstanding work is all done therefore reports
 * ``visitCount = 0``, an empty ``caregiverIds`` and ``uniform = false``. That is
 * honest rather than lossy: there is nothing left for a caregiver picker to
 * affect, and ``ServiceRequestLineUpdateReq.caregiverIds`` only ever staffs
 * visits a patch CREATES.
 */
export interface LineStaffingDb {
  /**
   * Caregiverids
   * The DISTINCT caregivers assigned to this line's outstanding (SCHEDULED or IN_PROGRESS) visits, ascending. Empty means none of those visits has a caregiver - which is NOT the same as uniform staffing by nobody: see uniform, which is false in that case. Never a single 'the line's caregiver': a line's visits need not share caregivers.
   */
  caregiverIds?: number[];
  /**
   * Uniform
   * True only when there is at least one outstanding visit, every one of them has exactly the same caregiver set, and that set is non-empty. False therefore covers all three unsafe cases at once: mixed staffing, partly-unstaffed, and entirely unstaffed. Re-staffing a whole line from caregiverIds is only lossless when this is true; when it is false, per-visit assignments exist that a line-level save would overwrite, so reassign through PATCH /visits/{visitId}.
   * @default false
   */
  uniform?: boolean;
  /**
   * Visitcount
   * How many visits were counted: the line's SCHEDULED and IN_PROGRESS ones. 0 means the line has no outstanding visits (all completed, all cancelled, or none generated), so the other fields are empty for want of anything to report rather than because nobody is assigned.
   * @default 0
   */
  visitCount?: number;
  /**
   * Staffedvisitcount
   * How many of those visits have at least one caregiver. Equal to visitCount when the line is fully staffed; between 1 and visitCount when it is partly staffed, which is also a reason uniform is false.
   * @default 0
   */
  staffedVisitCount?: number;
}

/**
 * PaymentSchedulePeriod
 * One collection: which visit collects it, the visits it covers, and how much.
 */
export interface PaymentSchedulePeriod {
  /** Index */
  index: number;
  /** Collectvisitid */
  collectVisitId?: number | null;
  /**
   * Collectat
   * @format date-time
   */
  collectAt: string;
  /**
   * Firstvisitat
   * @format date-time
   */
  firstVisitAt: string;
  /**
   * Lastvisitat
   * @format date-time
   */
  lastVisitAt: string;
  /** Visitcount */
  visitCount: number;
  /** Amount */
  amount: number;
  /**
   * Paid
   * @default 0
   */
  paid?: number;
  /** Outstanding */
  outstanding: number;
  /**
   * Due
   * @default false
   */
  due?: boolean;
  /** Collectvisitstatus */
  collectVisitStatus?: string | null;
  /**
   * Completedvisitcount
   * @default 0
   */
  completedVisitCount?: number;
}

/**
 * PaymentSchedulePreviewRequest
 * Body for POST /service-requests/payment-schedule/preview.
 */
export interface PaymentSchedulePreviewRequest {
  /**
   * Collecteveryn
   * @exclusiveMin 0
   */
  collectEveryN: number;
  /**
   * Mirror of ``enum_collect_unit``.
   *
   * ``MONTHS`` is a CALENDAR month, not 30 days - a monthly collection that
   * drifts two days a quarter is not a monthly collection. The arithmetic in
   * ``homecare.payments.collection`` walks calendar months for that reason.
   */
  collectUnit: CollectUnit;
  collectAnchor?: CollectAnchor | null;
  /** Collectanchorday */
  collectAnchorDay?: number | null;
  collectTiming?: CollectTiming | null;
  /** Timezone */
  timezone: string;
  /** Origin */
  origin?: string | null;
  /**
   * Visits
   * @maxItems 5000
   */
  visits: PaymentSchedulePreviewVisit[];
}

/** PaymentSchedulePreviewVisit */
export interface PaymentSchedulePreviewVisit {
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /** Price */
  price: number | string;
}

/** PaymentScheduleResponse */
export interface PaymentScheduleResponse {
  /** Periods */
  periods: PaymentSchedulePeriod[];
}

/**
 * ProtectedFromRepricingDb
 * One visit a repricing refused to rewrite, and why.
 *
 * :param reason: one of the independent facts - ``started``, ``status``,
 *     ``charged``, ``manually_repriced``, ``unmatched`` - or several joined in
 *     that order with ``_and_``. Composed rather than ranked, exactly as
 *     ``service_request_line_reconcile.protection_reason`` composes its own, so
 *     a coordinator is told every reason rather than an arbitrary winner.
 */
export interface ProtectedFromRepricingDb {
  /** Visitid */
  visitId: number;
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /** Reason */
  reason: string;
}

/**
 * ProtectedVisitDb
 * A visit regeneration refused to delete, and why.
 *
 * Returned so the UI can say *which* visits it left behind rather than only how
 * many — "3 visits kept" is not actionable, "the 12 Aug morning visit is already
 * completed and invoiced" is.
 *
 * :param status: an ``enum_visit_status`` label
 *     (SCHEDULED/IN_PROGRESS/COMPLETED/CANCELLED).
 * :param has_charge: whether a ``billing_transactions`` row points at the visit.
 * :param reason: one of the independent protection facts — ``status``,
 *     ``charged``, ``manually_rescheduled`` — or several of them joined in that
 *     order with ``_and_`` (``status_and_charged``,
 *     ``charged_and_manually_rescheduled``, ...); or ``protected_on_recheck``
 *     when the DELETE's own predicate refused a planned deletion. Built by
 *     ``app.crud.service_request_line_reconcile.protection_reason``, which
 *     composes rather than ranks so a coordinator is told every reason.
 */
export interface ProtectedVisitDb {
  /** Visitid */
  visitId: number;
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /**
   * Endtime
   * @format date-time
   */
  endTime: string;
  /** Status */
  status: string;
  /** Hascharge */
  hasCharge: boolean;
  /** Reason */
  reason: string;
}

/**
 * RepricedVisitDb
 * One visit a repricing rewrote, with what it now bills.
 *
 * Returned so the UI can say WHICH visits changed rather than only how many.
 * ``price_final`` is the amount that will be charged when the visit completes -
 * ``price_total`` less the line's discount.
 */
export interface RepricedVisitDb {
  /** Visitid */
  visitId: number;
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /** Pricetotal */
  priceTotal: string;
  /** Pricefinal */
  priceFinal: string;
}

/**
 * RequestAndVisitsServicesReq
 * Model for service requests services request payload
 */
export interface RequestAndVisitsServicesReq {
  /**
   * Id
   * ID of the service
   */
  id: number;
  /**
   * Cost
   * Cost of the service in Euros
   */
  cost: number;
  /**
   * Price
   * Price of the service in Euros
   */
  price: number;
}

/**
 * ServiceRequestCancelReq
 * Cancelling a request: why, and what to do about money not yet delivered.
 */
export interface ServiceRequestCancelReq {
  /**
   * Cancelreason
   * Why the request is being cancelled. Required, and stored on the request and on every visit this cancellation cancels - both carry a CHECK demanding it, so there is no cancelled record without one. Whitespace-only is rejected (the model strips before validating).
   * @minLength 1
   */
  cancelReason: string;
  /**
   * Voidunpaidcharges
   * Whether to void the request's unpaid lump-sum charges. Required with no default: a package is charged up front, so at cancellation time some of that money is for work that will now never happen and some clients have already been invoiced for it. Which of the two it is, is the operator's decision and not something a default can guess. Delivered work stays billed either way.
   */
  voidUnpaidCharges: boolean;
}

/**
 * ServiceRequestCancelResult
 * What cancelling the request actually did.
 *
 * The counts are what the database reported, not what was intended: a visit that
 * completed, or a charge that was paid, while the cancellation was in flight is
 * left alone and is not counted as changed.
 */
export interface ServiceRequestCancelResult {
  /** Servicerequestid */
  serviceRequestId: number;
  /** Cancelledvisitcount */
  cancelledVisitCount: number;
  /** Protectedvisitcount */
  protectedVisitCount: number;
  /** Voidedchargecount */
  voidedChargeCount: number;
  /** Keptchargecount */
  keptChargeCount: number;
}

/**
 * ServiceRequestCancellationPreview
 * What cancelling this request would do, before anyone commits to it.
 */
export interface ServiceRequestCancellationPreview {
  /**
   * Scheduledvisitcount
   * Visits that would be cancelled: SCHEDULED and starting from now on.
   */
  scheduledVisitCount: number;
  /**
   * Protectedvisitcount
   * Visits left exactly as they are: completed, in progress, already cancelled, or SCHEDULED in the past (unresolved history for a coordinator to close out, not future work).
   */
  protectedVisitCount: number;
  /**
   * Unpaidchargecount
   * Pending lump-sum charges on this request's service groups. Per-visit charges are raised only for completed visits, so they are delivered work and are never in this count.
   */
  unpaidChargeCount: number;
  /**
   * Unpaidchargetotal
   * Sum of those charges, to the cent.
   */
  unpaidChargeTotal: number;
  /**
   * Chargesvisible
   * Whether this session can read billing charges at all. False for a billing-blocked role (e.g. Office Administrator), whose charge counts above are therefore zero because the rows are invisible, NOT because there are none. A caller seeing false must not present the bill-or-not choice as if the figures were known.
   * @default true
   */
  chargesVisible?: boolean;
}

/**
 * ServiceRequestCreateReq
 * Model for service requests create request payload
 */
export interface ServiceRequestCreateReq {
  /**
   * Fromdate
   * @format date-time
   */
  fromDate: string;
  /**
   * Todate
   * @format date-time
   */
  toDate: string;
  /** Notes */
  notes?: string | null;
  /** Rrule */
  rrule?: string | null;
  status?: RequestStatusEnum | null;
  /**
   * Discountpercent
   * Discount percentage for the service
   */
  discountPercent?: number | null;
  paymentMethod?: PaymentMethod | null;
  /** Collecteveryn */
  collectEveryN?: number | null;
  collectUnit?: CollectUnit | null;
  /** Where a collection period starts. Omit for the pre-phase-5 behaviour: collectEveryN units measured from the earliest unpaid charge, with no calendar alignment. */
  collectAnchor?: CollectAnchor | null;
  /**
   * Collectanchorday
   * Day of month a 'day_of_month' anchored period starts on. 1..28 only: the 31st is not a day of February, and clamping it would make the collection date depend on the month. Month-end is the 'period_end' anchor, which is exact.
   */
  collectAnchorDay?: number | null;
  /** Which visit of each collection period collects: 'first_visit' (upfront) or 'last_visit' (after the service). Omitted = last_visit. */
  collectTiming?: CollectTiming | null;
  /** Clientid */
  clientId: number;
  /** Preferredcaregiverid */
  preferredCaregiverId?: number | null;
  /**
   * Services
   * @minItems 1
   */
  services: RequestAndVisitsServicesReq[];
  /** Visits */
  visits?: VisitCreateForServiceRequest[] | null;
  /**
   * Lines
   * Package-style scheduling: the arrangement - what recurs, at which times of day, containing which services. Lines are ALWAYS stored when supplied, together with their slots and slot services. What 'visits' changes is only whether they GENERATE: with no 'visits', each line expands into its own visits; with 'visits', the supplied visits are the line's visits and nothing is generated, so the client cannot be double-booked. Send both when a coordinator has already adjusted individual occurrences - each visit names its line through 'lineIndex'. Callers that send visits[] and no lines (the dashboard's scheduling board, both import scripts) are unaffected. Each line may carry its own 'caregiverIds', which staff that line's visits: a 09:00 bath line and a 20:00 medication line are usually worked by different people, so staffing belongs on the line rather than on the request. Those assignments are always shift-validated - 'forceCaregiverAssignment' applies to 'visits' only.
   */
  lines?: ServiceRequestLineCreateReq[] | null;
  /**
   * Forcecaregiverassignment
   * If True, allows assigning caregivers to visits even when they don't have shifts covering the visit times
   * @default false
   */
  forceCaregiverAssignment?: boolean;
}

/**
 * ServiceRequestLineCreateReq
 * One line of a service request: a period, a recurrence and slots.
 *
 * A slot may omit ``services`` only when ``package_id`` is set, in which case the
 * package's contents - including their quantities - are copied in. Without a
 * package every slot must still list at least one service, which is exactly the
 * rule that applied before packages existed.
 *
 * ``caregiver_ids`` staffs every visit the line generates - see
 * :class:`LineStaffingFields`. Omitting it leaves them unassigned, unchanged from
 * before the field existed.
 */
export interface ServiceRequestLineCreateReq {
  /**
   * Caregiverids
   * Caregivers to assign to every visit this line generates. Omit (or send an empty list) to leave them unassigned, which is the pre-staffing behaviour. When present, each caregiver must have a WORK shift covering every generated visit - a caregiver on leave is rejected with a 409 rather than booked.
   */
  caregiverIds?: number[] | null;
  paymentMethod?: PaymentMethod | null;
  /** Collecteveryn */
  collectEveryN?: number | null;
  collectUnit?: CollectUnit | null;
  /** Where a collection period starts. Omit for the pre-phase-5 behaviour: collectEveryN units measured from the earliest unpaid charge, with no calendar alignment. */
  collectAnchor?: CollectAnchor | null;
  /**
   * Collectanchorday
   * Day of month a 'day_of_month' anchored period starts on. 1..28 only: the 31st is not a day of February, and clamping it would make the collection date depend on the month. Month-end is the 'period_end' anchor, which is exact.
   */
  collectAnchorDay?: number | null;
  /** Which visit of each collection period collects: 'first_visit' (upfront) or 'last_visit' (after the service). Omitted = last_visit. */
  collectTiming?: CollectTiming | null;
  /**
   * Packageid
   * Catalog package this line was sold as. Provenance only - the line's contents are copied into its slot services at creation.
   */
  packageId?: number | null;
  /** Which number bills this line. Defaults to per_service, i.e. today's behaviour. A line sold with a packageId defaults to allocated - the package's price, spread over its slot services - or to per_service when no price resolves for the package. An explicit value always wins. */
  pricingMode?: LinePricingModeEnum | null;
  /** Price */
  price?: number | null;
  /** Cost */
  cost?: number | null;
  /** Discountpercent */
  discountPercent?: number | null;
  /**
   * Name
   * @minLength 1
   */
  name: string;
  /**
   * Fromdate
   * @format date-time
   */
  fromDate: string;
  /**
   * Todate
   * @format date-time
   */
  toDate: string;
  /** Rrule */
  rrule?: string | null;
  /**
   * Slots
   * @minItems 1
   */
  slots: ServiceRequestLineSlotCreateReq[];
}

/**
 * ServiceRequestLineDb
 * A persisted line with its slots.
 *
 * ``package_name`` is read from the catalog for display only. Everything about
 * what the line *contains* comes from ``slots``, which were populated when the
 * line was created - so a package renamed or re-specified since then changes the
 * label, never the sale.
 *
 * ``staffing`` is the only DERIVED member: it is computed from the line's visits
 * on read, because nothing about who works a line is stored on the line.
 */
export interface ServiceRequestLineDb {
  /** Lineid */
  lineId: number;
  /** Servicerequestid */
  serviceRequestId: number;
  /** Name */
  name: string;
  /**
   * Fromdate
   * @format date-time
   */
  fromDate: string;
  /**
   * Todate
   * @format date-time
   */
  toDate: string;
  /** Rrule */
  rrule?: string | null;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /**
   * Slots
   * @default []
   */
  slots?: ServiceRequestLineSlotDb[];
  /** Packageid */
  packageId?: number | null;
  /** Packagename */
  packageName?: string | null;
  /**
   * Mirror of the ``enum_line_pricing_mode`` Postgres type.
   *
   * Values are lowercase to match the database labels exactly, following
   * ``InventoryMovementTypeEnum`` and the other DB-backed enums in
   * ``models/inventory.py`` rather than the UPPERCASE domain enums in
   * ``models/enums.py``.
   *
   * ``PER_SERVICE`` is the pre-package behaviour and the column default: a line's
   * money is its slot-services' own cost/price. ``PACKAGE`` means the line's own
   * price/cost is authoritative, snapshotted when the package was sold.
   *
   * ``ALLOCATED`` and ``LUMP_SUM`` are phase 5, appended to the Postgres type with
   * ``ALTER TYPE ... ADD VALUE`` - no migration of existing rows and no breaking
   * change to callers that only ever send the first two.
   *
   * ``ALLOCATED`` spreads the line's own price back over its slot services, so
   * each delivered service carries a share and the ordinary per-visit billing
   * path bills the package. It is the mode ``PACKAGE`` left undone: a ``PACKAGE``
   * line's slot services carry no money at all, so its visits bill nothing.
   *
   * WHICH IS WHY SELLING A PACKAGE STORES ``ALLOCATED``, NOT ``PACKAGE``. A line
   * in ``PACKAGE`` mode is never invoiced by anything: its visits bill 0 and no
   * line-level charge is raised for it either (that is ``LUMP_SUM``'s job). See
   * ``_resolve_line_pricing``, which resolves a sale to ``ALLOCATED`` when a price
   * resolves for the package and to ``PER_SERVICE`` when none does. ``PACKAGE``
   * remains a storable, explicitly requestable mode, and the lines already written
   * in it keep their meaning - nothing here migrates them.
   *
   * ``LUMP_SUM`` bills the line ONCE, as a single amount, rather than per
   * delivered service. Its slot services carry no price and a single
   * ``client_charge`` is posted against the line - see
   * ``homecare.crud.line_billing_sync``.
   *
   * COST IS NEVER ALLOCATED in any mode. A cost is what the business pays a
   * caregiver; it does not shrink because the client got a bundle discount.
   * @default "per_service"
   */
  pricingMode?: LinePricingModeEnum;
  /** Price */
  price?: number | null;
  /** Cost */
  cost?: number | null;
  /** Discountpercent */
  discountPercent?: number | null;
  paymentMethod?: PaymentMethod | null;
  /** Collecteveryn */
  collectEveryN?: number | null;
  collectUnit?: CollectUnit | null;
  collectAnchor?: CollectAnchor | null;
  /** Collectanchorday */
  collectAnchorDay?: number | null;
  collectTiming?: CollectTiming | null;
  /** Who staffs this line, derived from its outstanding (SCHEDULED or IN_PROGRESS) visits - not stored on the line. Reports the DISTINCT caregivers across those visits plus whether staffing is uniform, because a line's visits need not share caregivers. null means the field was not computed, which is not the same as nobody assigned. */
  staffing?: LineStaffingDb | null;
  /** What repricing this update actually did, present only when the patch asked for one. The APPLIED result, not the dry run - a visit that completed since the preview is protected here and was not there. */
  repricing?: LineRepricingSummary | null;
}

/**
 * ServiceRequestLineSlotCreateReq
 * A repeating time-of-day window and what happens in it.
 *
 * The two bounds are timezone-aware instants (``TIMESTAMPTZ``), so a slot is the
 * same kind of value as the visit it produces and needs no out-of-band zone to be
 * read correctly. Only their wall clock in the line's timezone is
 * scheduling-significant — see :mod:`homecare.scheduling.expand`.
 */
export interface ServiceRequestLineSlotCreateReq {
  /**
   * Ordinal
   * @min 1
   */
  ordinal: number;
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /**
   * Endtime
   * @format date-time
   */
  endTime: string;
  /** Services */
  services?: ServiceRequestLineSlotServiceReq[] | null;
}

/**
 * ServiceRequestLineSlotDb
 * A persisted slot with its services.
 *
 * ``start_time``/``end_time`` are the ``TIMESTAMPTZ`` anchors, serialised with
 * their offset, so a client renders a slot exactly as it renders
 * ``visits.start_time`` rather than printing a zoneless string.
 */
export interface ServiceRequestLineSlotDb {
  /** Slotid */
  slotId: number;
  /** Lineid */
  lineId: number;
  /** Ordinal */
  ordinal: number;
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /**
   * Endtime
   * @format date-time
   */
  endTime: string;
  /**
   * Services
   * @default []
   */
  services?: ServiceRequestLineSlotServiceDb[];
}

/**
 * ServiceRequestLineSlotServiceDb
 * A persisted slot service.
 */
export interface ServiceRequestLineSlotServiceDb {
  /** Serviceid */
  serviceId: number;
  /**
   * Quantity
   * @exclusiveMin 0
   * @default 1
   */
  quantity?: number;
  /** Cost */
  cost?: number | null;
  /** Price */
  price?: number | null;
  /** Slotserviceid */
  slotServiceId: number;
  /** Slotid */
  slotId: number;
}

/**
 * ServiceRequestLineSlotServiceReq
 * A service delivered in one slot, with a per-occurrence quantity.
 *
 * ``quantity`` counts repetitions *within* a single visit — materials or a
 * unit-billed service. Time-separated repetition is modelled as extra slots,
 * never as quantity.
 */
export interface ServiceRequestLineSlotServiceReq {
  /** Serviceid */
  serviceId: number;
  /**
   * Quantity
   * @exclusiveMin 0
   * @default 1
   */
  quantity?: number;
  /** Cost */
  cost?: number | null;
  /** Price */
  price?: number | null;
}

/**
 * ServiceRequestLineUpdateReq
 * A partial line update. Every field optional; at least one required.
 *
 * ``slots`` replaces the line's slots wholesale rather than patching them: a
 * slot's identity is its ordinal, and partial slot patching would need its own
 * sub-resource API for marginal benefit.
 *
 * ``caregiver_ids`` staffs the visits this patch's reconciliation CREATES, and
 * nothing else - see :meth:`_validate_caregivers_need_a_regeneration` and
 * ``app.crud.service_request_line.update_line``.
 *
 * There is deliberately no from_date <= to_date validator here. A PATCH may
 * supply only one of the two dates, with the other coming from the stored row,
 * so the effective range can only be checked once the payload is merged - which
 * is the CRUD layer's job, not the model's.
 */
export interface ServiceRequestLineUpdateReq {
  /**
   * Caregiverids
   * Caregivers to assign to every visit this line generates. Omit (or send an empty list) to leave them unassigned, which is the pre-staffing behaviour. When present, each caregiver must have a WORK shift covering every generated visit - a caregiver on leave is rejected with a 409 rather than booked.
   */
  caregiverIds?: number[] | null;
  paymentMethod?: PaymentMethod | null;
  /** Collecteveryn */
  collectEveryN?: number | null;
  collectUnit?: CollectUnit | null;
  /** Where a collection period starts. Omit for the pre-phase-5 behaviour: collectEveryN units measured from the earliest unpaid charge, with no calendar alignment. */
  collectAnchor?: CollectAnchor | null;
  /**
   * Collectanchorday
   * Day of month a 'day_of_month' anchored period starts on. 1..28 only: the 31st is not a day of February, and clamping it would make the collection date depend on the month. Month-end is the 'period_end' anchor, which is exact.
   */
  collectAnchorDay?: number | null;
  /** Which visit of each collection period collects: 'first_visit' (upfront) or 'last_visit' (after the service). Omitted = last_visit. */
  collectTiming?: CollectTiming | null;
  /**
   * Packageid
   * Catalog package this line was sold as. Provenance only - the line's contents are copied into its slot services at creation.
   */
  packageId?: number | null;
  /** Which number bills this line. Defaults to per_service, i.e. today's behaviour. A line sold with a packageId defaults to allocated - the package's price, spread over its slot services - or to per_service when no price resolves for the package. An explicit value always wins. */
  pricingMode?: LinePricingModeEnum | null;
  /** Price */
  price?: number | null;
  /** Cost */
  cost?: number | null;
  /** Discountpercent */
  discountPercent?: number | null;
  /** Name */
  name?: string | null;
  /** Fromdate */
  fromDate?: string | null;
  /** Todate */
  toDate?: string | null;
  /** Rrule */
  rrule?: string | null;
  /** Slots */
  slots?: ServiceRequestLineSlotCreateReq[] | null;
  /**
   * Repricefuturevisits
   * @default false
   */
  repriceFutureVisits?: boolean;
}

/**
 * ServiceRequestResponse
 * Model for service requests response body
 */
export interface ServiceRequestResponse {
  /**
   * Fromdate
   * @format date-time
   */
  fromDate: string;
  /**
   * Todate
   * @format date-time
   */
  toDate: string;
  /** Notes */
  notes?: string | null;
  /** Rrule */
  rrule?: string | null;
  status: RequestStatusEnum;
  /**
   * Discountpercent
   * Discount percentage for the service
   */
  discountPercent?: number | null;
  paymentMethod?: PaymentMethod | null;
  /** Collecteveryn */
  collectEveryN?: number | null;
  collectUnit?: CollectUnit | null;
  /** Where a collection period starts. Omit for the pre-phase-5 behaviour: collectEveryN units measured from the earliest unpaid charge, with no calendar alignment. */
  collectAnchor?: CollectAnchor | null;
  /**
   * Collectanchorday
   * Day of month a 'day_of_month' anchored period starts on. 1..28 only: the 31st is not a day of February, and clamping it would make the collection date depend on the month. Month-end is the 'period_end' anchor, which is exact.
   */
  collectAnchorDay?: number | null;
  /** Which visit of each collection period collects: 'first_visit' (upfront) or 'last_visit' (after the service). Omitted = last_visit. */
  collectTiming?: CollectTiming | null;
  /** Servicerequestid */
  serviceRequestId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /** Client with service request details */
  client: ClientServiceRequestResponse;
  preferredCaregiver?: CaregiverServiceRequestResponse | null;
  /** Services */
  services: ServiceServiceRequestResponse[];
  /**
   * Costtotal
   * Cost of the service in Euros
   */
  costTotal?: number | null;
  /**
   * Pricetotal
   * Price of the service in Euros
   */
  priceTotal?: number | null;
  /**
   * Pricefinal
   * Price final for the service request
   */
  priceFinal?: number | null;
  /**
   * Visitcount
   * Number of visits attached to this service request
   * @default 0
   */
  visitCount?: number;
  /**
   * Linecount
   * Number of service-request lines on this service request
   * @default 0
   */
  lineCount?: number;
  /**
   * Packagenames
   * Names of the packages this request's lines were sold from
   */
  packageNames?: string[];
  /**
   * Cancelreason
   * Why the request was cancelled. Always present on a CANCELLED request (chk_sr_cancel_reason_present), NULL otherwise.
   */
  cancelReason?: string | null;
  /**
   * Cancelledat
   * When the request was cancelled. Best-effort rather than guaranteed: requests cancelled before this column existed carry a backfilled timestamp, and no constraint ties it to the status.
   */
  cancelledAt?: string | null;
}

/**
 * ServiceRequestUpdateReq
 * Model for service requests update request payload
 */
export interface ServiceRequestUpdateReq {
  /** Fromdate */
  fromDate?: string | null;
  /** Todate */
  toDate?: string | null;
  /** Notes */
  notes?: string | null;
  /** Rrule */
  rrule?: string | null;
  status?: RequestStatusEnum | null;
  /**
   * Discountpercent
   * Discount percentage for the service
   */
  discountPercent?: number | null;
  paymentMethod?: PaymentMethod | null;
  /** Collecteveryn */
  collectEveryN?: number | null;
  collectUnit?: CollectUnit | null;
  /** Where a collection period starts. Omit for the pre-phase-5 behaviour: collectEveryN units measured from the earliest unpaid charge, with no calendar alignment. */
  collectAnchor?: CollectAnchor | null;
  /**
   * Collectanchorday
   * Day of month a 'day_of_month' anchored period starts on. 1..28 only: the 31st is not a day of February, and clamping it would make the collection date depend on the month. Month-end is the 'period_end' anchor, which is exact.
   */
  collectAnchorDay?: number | null;
  /** Which visit of each collection period collects: 'first_visit' (upfront) or 'last_visit' (after the service). Omitted = last_visit. */
  collectTiming?: CollectTiming | null;
  /** Preferredcaregiverid */
  preferredCaregiverId?: number | null;
  /** Services */
  services?: RequestAndVisitsServicesReq[] | null;
}

/** ServiceRequestsGetAllPaginationResponse */
export interface ServiceRequestsGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: ServiceRequestResponse[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/**
 * ServiceServiceRequestResponse
 * Response model for service data in service requests.
 */
export interface ServiceServiceRequestResponse {
  /**
   * Serviceid
   * Unique identifier for the service (PK of services table)
   */
  serviceId: number;
  /**
   * Name
   * Name of the specific service
   */
  name: string;
  /**
   * Description
   * Detailed description of the service offering
   */
  description?: string | null;
  /**
   * Cost
   * Cost of the service in Euros
   */
  cost?: number | null;
  /**
   * Price
   * Price of the service in Euros
   */
  price?: number | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/**
 * VisitCreateForServiceRequest
 * Model for creating visits within a service request transaction.
 *
 * Inherits from VisitBase but doesn't require service_request_id
 * since it will be set automatically.
 */
export interface VisitCreateForServiceRequest {
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /**
   * Endtime
   * @format date-time
   */
  endTime: string;
  /** Completedat */
  completedAt?: string | null;
  /** Checkinat */
  checkInAt?: string | null;
  /** Remindersentat */
  reminderSentAt?: string | null;
  /** Street */
  street: string;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  status?: VisitStatusEnum | null;
  /** Canceldate */
  cancelDate?: string | null;
  /** Cancelreason */
  cancelReason?: string | null;
  /**
   * Referringdoctorid
   * Referring doctor ID at the time of visit creation
   */
  referringDoctorId?: number | null;
  /**
   * Attendingdoctorid
   * Attending doctor ID at the time of visit creation
   */
  attendingDoctorId?: number | null;
  /** Heartrate */
  heartRate?: number | null;
  /** Oxygensaturation */
  oxygenSaturation?: number | null;
  /** Respiratoryrate */
  respiratoryRate?: number | null;
  /** Co2Level */
  co2Level?: number | null;
  /** Temperature */
  temperature?: number | null;
  /** Bloodpressuresystolic */
  bloodPressureSystolic?: number | null;
  /** Bloodpressurediastolic */
  bloodPressureDiastolic?: number | null;
  /** Bloodglucose */
  bloodGlucose?: number | null;
  /** Weight */
  weight?: number | null;
  /** Height */
  height?: number | null;
  /** Bmi */
  bmi?: number | null;
  /** Painscale */
  painScale?: number | null;
  /** Fvc */
  fvc?: number | null;
  /** Fev1 */
  fev1?: number | null;
  /**
   * Discountpercent
   * Discount percentage for the service
   */
  discountPercent?: number | null;
  /**
   * Note
   * A note to file against this visit as it is created, written by the calling user and readable by the office and the care team. Blank or whitespace-only files nothing. Accepted only on creation; use `POST /clients/{clientId}/notes` afterwards, and `GET /visits/{visitId}/notes` to read a visit's notes.
   */
  note?: string | null;
  /** Clientid */
  clientId: number;
  /** Caregiverids */
  caregiverIds?: number[] | null;
  /**
   * Services
   * @minItems 1
   */
  services: RequestAndVisitsServicesReq[];
  /**
   * Lineindex
   * Zero-based index into this request's 'lines' array, naming the line this visit belongs to. Use it when supplying both 'lines' and 'visits': the lines record the arrangement, the visits are the concrete appointments a coordinator has already adjusted. An index rather than an id because the lines are created by this same call. A visit whose start does not fall on its line's pattern is stored with 'manuallyRescheduled' set, so line regeneration never moves or deletes it and never refills the pattern time it was moved away from. Must be within range of 'lines' (400 otherwise).
   */
  lineIndex?: number | null;
  /**
   * Slotordinal
   * 1-based ordinal of the line slot this visit was built from. Send it alongside 'lineIndex' when supplying visits for a line whose pricing mode allocates money across its slot services ('allocated', 'lump_sum'): the per-service shares are computed server-side, so the visit's own service prices are filled in from that slot rather than taken from the payload. Ignored on every other pricing mode, where the supplied money is authoritative. Must name a slot the line actually has (400 otherwise).
   */
  slotOrdinal?: number | null;
}

/**
 * VoiceCreateVisitReq
 * Minimal payload sent by the mobile voice feature to create a visit.
 *
 * The mobile client speaks a local wall-clock date/time and only knows the
 * client and service ids. The server enriches this with the client address,
 * per-service cost/price and the user's timezone before delegating to the
 * normal service-request create path. camelCase aliases (clientId,
 * serviceIds, startTime, endTime) are accepted via the shared _BaseModel
 * alias generator.
 */
export interface VoiceCreateVisitReq {
  /** Clientid */
  clientId: number;
  /**
   * Serviceids
   * @minItems 1
   */
  serviceIds: number[];
  /**
   * Date
   * Local calendar date, YYYY-MM-DD
   */
  date: string;
  /**
   * Starttime
   * Local wall-clock start, HH:mm
   */
  startTime: string;
  /**
   * Endtime
   * Local wall-clock end, HH:mm
   */
  endTime: string;
  /** Notes */
  notes?: string | null;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api/v1/requests-api/',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title service-requests
 * @version 1.0.0
 * @baseUrl /api/v1/requests-api/
 *
 *
 * Microservice for managing home care service requests.
 *
 * ## Features
 * * Create, read, update, and delete service request records
 * * Secure endpoints with authentication and authorization
 *
 * ## Authentication
 * All endpoints require authentication using JWT tokens.
 * Admin endpoints require additional admin permissions.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  health = {
    /**
     * @description Returns the health status and version of the service
     *
     * @tags Health
     * @name HealthCheckHealthGet
     * @summary Health check endpoint
     * @request GET:/health
     * @secure
     */
    healthCheckHealthGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  serviceRequests = {
    /**
     * @description Retrieve a paginated list of service requests. Provide 'query' (min 3 chars) to perform free-text search across notes, client/caregiver names, and service names. Supports JSON:API filtering with filter[fieldName][operator]=value syntax.
     *
     * @tags Service Requests
     * @name ListServiceRequests
     * @summary Get service requests (list or search)
     * @request GET:/service-requests
     * @secure
     */
    listServiceRequests: (
      query?: {
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'created_at,-service_request_id'. Prefix with '-' for DESC.
         * @default "service_request_id"
         */
        sort?: string | null;
        /**
         * Aggregate
         * JSON object specifying aggregations. Example: {"fields":{"costTotal":["sum","avg"],"estimatedDurationMinutes":["sum"],"discountPercent":["avg"]}}
         */
        aggregate?: string | null;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<ServiceRequestsGetAllPaginationResponse, void>({
        path: `/service-requests`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a service request, its arrangement and its visits in one transaction. 'lines' are the arrangement (what recurs, at which times of day, containing which services) and are ALWAYS stored when supplied, with their slots and slot services. 'visits' are concrete appointments. What 'visits' replaces is only whether the lines GENERATE: with no 'visits', each line expands into its own visits; with 'visits', the supplied visits are taken to be the lines' visits and nothing is generated, so the client is not double-booked. Send both to create a programme whose individual occurrences a coordinator has already adjusted: each visit names its line with 'lineIndex' (a position in 'lines', since the lines have no ids yet), and a visit that does not fall on its line's pattern is stored with 'manuallyRescheduled' set - derived here by expanding the line, never taken from the payload - so regeneration will neither move it nor refill the pattern time it was moved away from. A 'lineIndex' out of range of 'lines' is rejected (422). With status 'UNFULFILLED' the lines, their slots and their services are still stored in full but NO visits are generated: the request records the arrangement without scheduling anybody. 'UNFULFILLED' together with an explicit 'visits' array is rejected (422), because the two contradict each other. To schedule an unfulfilled request later, PATCH its status to 'SUBMITTED' and then regenerate each line's visits.
     *
     * @tags Service Requests
     * @name CreateServiceRequest
     * @summary Create service request
     * @request POST:/service-requests
     * @secure
     */
    createServiceRequest: (data: ServiceRequestCreateReq, params: RequestParams = {}) =>
      this.request<ServiceRequestResponse, void>({
        path: `/service-requests`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a specific service request by its ID
     *
     * @tags Service Requests
     * @name GetServiceRequestById
     * @summary Get service request by ID
     * @request GET:/service-requests/{request_id}
     * @secure
     */
    getServiceRequestById: (requestId: number, params: RequestParams = {}) =>
      this.request<ServiceRequestResponse, void | HTTPValidationError>({
        path: `/service-requests/${requestId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new service request
     *
     * @tags Service Requests
     * @name UpdateServiceRequest
     * @summary Create service request
     * @request PUT:/service-requests/{request_id}
     * @secure
     */
    updateServiceRequest: (requestId: number, data: ServiceRequestUpdateReq, params: RequestParams = {}) =>
      this.request<ServiceRequestResponse, void | HTTPValidationError>({
        path: `/service-requests/${requestId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a service request by its ID
     *
     * @tags Service Requests
     * @name DeleteServiceRequest
     * @summary Delete a service request
     * @request DELETE:/service-requests/{request_id}
     * @secure
     */
    deleteServiceRequest: (requestId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/service-requests/${requestId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Every collection of the request under its cadence: which visit collects it, the visits it covers, the amount, what has been paid and whether it is due. Empty when the request has no cadence or no visits. Visits whose line sets its own cadence are not part of the request's schedule. Pass collectEveryN and collectUnit (and optionally the anchor and timing) to see the schedule the request WOULD have under unsaved settings.
     *
     * @tags Service Requests
     * @name GetServiceRequestPaymentSchedule
     * @summary Get a service request's payment schedule
     * @request GET:/service-requests/{request_id}/payment-schedule
     * @secure
     */
    getServiceRequestPaymentSchedule: (
      requestId: number,
      query?: {
        /** Collecteveryn */
        collectEveryN?: number | null;
        /** Collectunit */
        collectUnit?: CollectUnit | null;
        /** Collectanchor */
        collectAnchor?: CollectAnchor | null;
        /** Collectanchorday */
        collectAnchorDay?: number | null;
        /** Collecttiming */
        collectTiming?: CollectTiming | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaymentScheduleResponse, void | HTTPValidationError>({
        path: `/service-requests/${requestId}/payment-schedule`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description The schedule a cadence would produce for the given planned visits, before anything is saved. Writes nothing.
     *
     * @tags Service Requests
     * @name PreviewPaymentSchedule
     * @summary Preview a payment schedule
     * @request POST:/service-requests/payment-schedule/preview
     * @secure
     */
    previewPaymentSchedule: (data: PaymentSchedulePreviewRequest, params: RequestParams = {}) =>
      this.request<PaymentScheduleResponse, void>({
        path: `/service-requests/payment-schedule/preview`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Dry run: reports what cancelling this request would do - how many scheduled visits would be cancelled, how many visits would be left exactly as they are because they are completed, in progress, already cancelled or scheduled in the past, and how many unpaid package charges there are with their total. Writes nothing and locks nothing: the visit split is computed by the same statement the cancel uses, so the preview cannot disagree with what the cancel will then do. GET because it is safe and repeatable. A request that is already cancelled is described rather than refused - it simply has no upcoming scheduled visits left - because this is what the confirmation dialog reads before it can know that. 'chargesVisible' says whether the charge figures can be believed: a billing-blocked role (e.g. Office Administrator) passes this endpoint's role check but is denied every billing row by RLS, so its charge counts come back zero because the rows are invisible and not because there are none. When it is false, do not present the bill-or-not choice as if the figures were known.
     *
     * @tags Service Requests
     * @name PreviewServiceRequestCancellation
     * @summary Preview cancelling a service request
     * @request GET:/service-requests/{request_id}/cancellation-preview
     * @secure
     */
    previewServiceRequestCancellation: (requestId: number, params: RequestParams = {}) =>
      this.request<ServiceRequestCancellationPreview, void | HTTPValidationError>({
        path: `/service-requests/${requestId}/cancellation-preview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Cancels the request and its upcoming work in one transaction. Sets the status to CANCELLED with the supplied reason, and cancels every visit that is SCHEDULED and starts from now on, stamping the same reason onto each - nothing is deleted, so the visits and their history survive. Visits that are completed, in progress, already cancelled, or scheduled in the past are left exactly as they are and stay billed: a delivered visit is not un-delivered by calling the request off, and a past scheduled visit is unresolved history for a coordinator to close out. Protection is re-checked inside the transaction, so a visit that completed since the preview survives. 'voidUnpaidCharges' decides what happens to the request's unpaid package charges - they are raised up front, for work that has not happened yet - and is required with no default, because it is the one thing no default can guess; per-visit charges are never touched. Refused with a 400 when the request is already cancelled: a second call would overwrite the first reason and re-run the billing decision. Also refused with a 400 when 'voidUnpaidCharges' is true but the session cannot read billing rows at all (a billing-blocked role such as Office Administrator), because the void would silently change nothing and a 200 would report a write-off that did not happen; cancelling while KEEPING the charges is allowed from such a session, since it touches no billing row. See 'chargesVisible' on the cancellation preview.
     *
     * @tags Service Requests
     * @name CancelServiceRequest
     * @summary Cancel a service request
     * @request POST:/service-requests/{request_id}/cancel
     * @secure
     */
    cancelServiceRequest: (requestId: number, data: ServiceRequestCancelReq, params: RequestParams = {}) =>
      this.request<ServiceRequestCancelResult, void | HTTPValidationError>({
        path: `/service-requests/${requestId}/cancel`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Initiate an export of service request data (runs in background).
     *
     * @tags Service Requests
     * @name ExportServiceRequestData
     * @summary Export service request data
     * @request POST:/service-requests/export
     * @secure
     */
    exportServiceRequestData: (
      query?: {
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'created_at,-service_request_id'. Prefix with '-' for DESC.
         * @default "service_request_id"
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError | void>({
        path: `/service-requests/export`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Download a previously generated service request data export file by path.
     *
     * @tags Service Requests
     * @name DownloadServiceRequestExport
     * @summary Download exported service request data CSV file
     * @request GET:/service-requests/export/download
     * @secure
     */
    downloadServiceRequestExport: (
      query: {
        /**
         * File Path
         * Full path of the exported CSV file
         */
        file_path: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void | HTTPValidationError>({
        path: `/service-requests/export/download`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates one line - a period, a recurrence and its per-day time slots - on an existing service request, generates the visits it expands to, and recomputes the request's date envelope, all in the same transaction. 'caregiverIds' staffs every visit the line generates; each caregiver must have a WORK shift covering every generated visit, so a caregiver on approved leave is rejected with a 409 rather than booked. Omitting it leaves the generated visits unassigned. On a request whose status is UNFULFILLED or CANCELLED the line and its slots are still stored in full but NO visits are generated - an unfulfilled request records the arrangement without scheduling anybody - so a staffed line on one assigns nobody and validates no shifts.
     *
     * @tags Service Request Lines
     * @name CreateServiceRequestLine
     * @summary Create a service request line
     * @request POST:/service-requests/{service_request_id}/lines
     * @secure
     */
    createServiceRequestLine: (
      serviceRequestId: number,
      data: ServiceRequestLineCreateReq,
      params: RequestParams = {}
    ) =>
      this.request<ServiceRequestLineDb, void | HTTPValidationError>({
        path: `/service-requests/${serviceRequestId}/lines`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns every line of the request, each with its slots and their services, plus 'staffing': who works the line, derived from its outstanding (SCHEDULED or IN_PROGRESS) visits rather than stored on the line. It reports the DISTINCT caregivers across those visits and whether staffing is uniform, because a line's visits need not share caregivers - an individual visit is reassigned through PATCH /visits/{visitId}. A caregiver picker prefilled from caregiverIds is only lossless to save back when uniform is true.
     *
     * @tags Service Request Lines
     * @name ListServiceRequestLines
     * @summary List a service request's lines
     * @request GET:/service-requests/{service_request_id}/lines
     * @secure
     */
    listServiceRequestLines: (serviceRequestId: number, params: RequestParams = {}) =>
      this.request<ServiceRequestLineDb[], HTTPValidationError | void>({
        path: `/service-requests/${serviceRequestId}/lines`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Patches a line's own fields. Supplying 'slots' replaces the line's slots wholesale rather than patching them, because a slot's identity is its ordinal. When the patch touches fromDate, toDate, rrule or slots, the line's already-generated visits are reconciled with the new definition - protected visits (in progress, completed, cancelled or charged) are never moved or removed. A name-only patch reconciles nothing. Recomputes the request's date envelope in the same transaction. 'caregiverIds' staffs the visits this reconciliation CREATES and nothing else: visits that already exist are never re-staffed, so reassigning one stays a PATCH on the visit. It therefore requires a schedule-affecting field alongside it (422 otherwise), and a caregiver with no covering WORK shift is refused with a 409. On a request whose status is UNFULFILLED or CANCELLED the patch applies and the reconciliation is a no-op: there are no visits on either side, and editing the arrangement of an unfulfilled request must stay possible. The status is never changed as a side effect.
     *
     * @tags Service Request Lines
     * @name UpdateServiceRequestLine
     * @summary Update a service request line
     * @request PATCH:/service-requests/{service_request_id}/lines/{line_id}
     * @secure
     */
    updateServiceRequestLine: (
      serviceRequestId: number,
      lineId: number,
      data: ServiceRequestLineUpdateReq,
      params: RequestParams = {}
    ) =>
      this.request<ServiceRequestLineDb, void | HTTPValidationError>({
        path: `/service-requests/${serviceRequestId}/lines/${lineId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a line; its slots and slot services cascade. Visits already generated by the line are preserved - their service_request_line_id becomes NULL - so visit history survives. Recomputes the envelope.
     *
     * @tags Service Request Lines
     * @name DeleteServiceRequestLine
     * @summary Delete a service request line
     * @request DELETE:/service-requests/{service_request_id}/lines/{line_id}
     * @secure
     */
    deleteServiceRequestLine: (serviceRequestId: number, lineId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/service-requests/${serviceRequestId}/lines/${lineId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Of the services this line promised, how many are done and how many remain - per service and in total. Built from the line's real visits and their services, not from re-expanding the line's definition: the definition says what the line would generate today, while the visits say what was actually scheduled, and the two diverge as soon as a visit is cancelled or regeneration leaves a protected one in place. COMPLETED counts as delivered; SCHEDULED and IN_PROGRESS count as outstanding, because money is only booked on completion; CANCELLED counts as neither and is reported on its own. Counts are in service units, so a per-day quantity of 2 counts twice.
     *
     * @tags Service Request Lines
     * @name GetServiceRequestLineDelivery
     * @summary What has been delivered against a line
     * @request GET:/service-requests/{service_request_id}/lines/{line_id}/delivery
     * @secure
     */
    getServiceRequestLineDelivery: (serviceRequestId: number, lineId: number, params: RequestParams = {}) =>
      this.request<LineDeliveryReport, void | HTTPValidationError>({
        path: `/service-requests/${serviceRequestId}/lines/${lineId}/delivery`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Dry run: reports what regenerating this line's visits would do - how many would be created, how many kept, how many deleted, and which ones would be left alone because they are protected (in progress, completed, cancelled, carrying a charge, or moved by hand). Writes nothing: the same shared planner the apply uses is executed with reads only, so the preview cannot disagree with what the apply will then do. GET because it is safe and repeatable. Returns 400 when the request's status is UNFULFILLED or CANCELLED, which is the same refusal the apply gives - reporting 'nothing would change' while the apply refused would be exactly the disagreement this endpoint exists to prevent.
     *
     * @tags Service Request Lines
     * @name PreviewServiceRequestLineVisitRegeneration
     * @summary Preview regenerating a line's visits
     * @request GET:/service-requests/{service_request_id}/lines/{line_id}/visit-regeneration-preview
     * @secure
     */
    previewServiceRequestLineVisitRegeneration: (
      serviceRequestId: number,
      lineId: number,
      params: RequestParams = {}
    ) =>
      this.request<LineRegenerationSummary, void | HTTPValidationError>({
        path: `/service-requests/${serviceRequestId}/lines/${lineId}/visit-regeneration-preview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Which of the line's visits would have their money rewritten by a patch that reprices, and which would be left alone and why. Writes nothing. It answers only the half that does NOT depend on the pending edit - eligibility and protection. The AMOUNTS depend on what is being saved and are computed by the client from the draft, the same split the visit-regeneration preview already uses. `chargesVisible` is false when the calling session may not write `billing_transactions` (an Office Administrator, refused by the RESTRICTIVE billing-blocked policies). Nothing is eligible in that case, because an unseen charge would read as no charge.
     *
     * @tags Service Request Lines
     * @name PreviewServiceRequestLineRepricing
     * @summary Preview repricing this line's future visits
     * @request GET:/service-requests/{service_request_id}/lines/{line_id}/repricing-preview
     * @secure
     */
    previewServiceRequestLineRepricing: (serviceRequestId: number, lineId: number, params: RequestParams = {}) =>
      this.request<LineRepricingSummary, void | HTTPValidationError>({
        path: `/service-requests/${serviceRequestId}/lines/${lineId}/repricing-preview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reconciles the line's visits with its current definition: deletes the unprotected visits it no longer calls for, creates the missing ones, keeps the ones that still match, and leaves protected visits (in progress, completed, cancelled, carrying a charge, or moved by hand) untouched - deleting those would destroy delivery history, orphan settled money, or silently undo a coordinator's decision about when one occurrence happens. A hand-moved visit also counts as satisfying the occurrence it was moved away from, so the vacated pattern time is not refilled with a duplicate. Protection is re-checked inside the transaction immediately before deleting, so a visit that completed or was hand-moved since the preview survives. Recomputes the envelope. Refused with a 400 while the request's status is UNFULFILLED or CANCELLED: such a request schedules nobody, so generating visits for it would leave the status contradicting the visits. To fulfil an unfulfilled request, PATCH its status to SUBMITTED first, then regenerate each line.
     *
     * @tags Service Request Lines
     * @name RegenerateServiceRequestLineVisits
     * @summary Regenerate a line's visits
     * @request POST:/service-requests/{service_request_id}/lines/{line_id}/regenerate-visits
     * @secure
     */
    regenerateServiceRequestLineVisits: (serviceRequestId: number, lineId: number, params: RequestParams = {}) =>
      this.request<LineRegenerationSummary, void | HTTPValidationError>({
        path: `/service-requests/${serviceRequestId}/lines/${lineId}/regenerate-visits`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  voice = {
    /**
     * @description Creates a service request (and its single visit) from the minimal payload sent by the mobile voice feature. The server enriches the payload with the client's address, per-service cost/price and the user's timezone, then reuses the standard create logic.
     *
     * @tags Service Requests
     * @name CreateVoiceVisit
     * @summary Create a visit from a minimal voice payload
     * @request POST:/voice/create-visit
     * @secure
     */
    createVoiceVisit: (data: VoiceCreateVisitReq, params: RequestParams = {}) =>
      this.request<ServiceRequestResponse, void | HTTPValidationError>({
        path: `/voice/create-visit`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
